/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Move_UpInputs */

const en_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

const fr_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monter en gamme`)
};

const de_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsteigen`)
};

const it_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostarsi verso l'alto`)
};

const ru_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поднимитесь выше`)
};

const es_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir`)
};

const zh_cn2_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向上`)
};

const ja_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上へ進む`)
};

const hi_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बढ़ाना`)
};

const pt_pt2_media_tab_move_up = /** @type {(inputs: Media_Tab_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suba`)
};

/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Media_Tab_Move_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_move_up = /** @type {((inputs?: Media_Tab_Move_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Move_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_move_up(inputs)
	if (locale === "de") return de_media_tab_move_up(inputs)
	if (locale === "it") return it_media_tab_move_up(inputs)
	if (locale === "ru") return ru_media_tab_move_up(inputs)
	if (locale === "es") return es_media_tab_move_up(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_move_up(inputs)
	if (locale === "ja") return ja_media_tab_move_up(inputs)
	if (locale === "hi") return hi_media_tab_move_up(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_move_up(inputs)
	return en_media_tab_move_up(inputs)
});